import { Route } from 'react-router-dom';
import LoginPages from './LoginPages';
import LogoutPage from './LogoutPage';
import PasswordResetPages from './PasswordResetPages';
import SignUpPage from './SignUpPage';

export function buildAuthRoutes() {
    return [
        <Route path="/login/*" key="login" element={<LoginPages />} />,
        <Route path="/signup/:activateToken" key="signup" element={<SignUpPage />} />,
        <Route path="/logout" key="logout" element={<LogoutPage />} />,
        <Route path="/reset/*" key="reset" element={<PasswordResetPages />} />,
    ];
}
